import api from "../../services/api";

export const admin = {
    namespaced: true,
    state: () => ({
        token: localStorage.getItem("admin_token") || null,
        email: localStorage.getItem("admin_email") || null,
        loading: false,
        error: null,
    }),
    getters: {
        isAuthenticated: (state) => !!state.token,
        authEmail: (state) => state.email,
        isLoading: (state) => state.loading,
    },
    mutations: {
        SET_TOKEN(state, token) {
            state.token = token;
            localStorage.setItem("admin_token", token);
        },
        SET_EMAIL(state, email) {
            state.email = email;
            localStorage.setItem("admin_email", email);
        },
        LOGOUT(state) {
            state.token = null;
            state.email = null;
            localStorage.removeItem("admin_token");
            localStorage.removeItem("admin_email");
        },
        SET_LOADING(state, value) {
            state.loading = value;
        },
        SET_ERROR(state, error) {
            state.error = error;
        },
    },
    actions: {
        async login({ commit }, credentials) {
            commit("SET_LOADING", true);
            commit("SET_ERROR", null);
            try {
                const response = await api.post("/Auth/login", credentials);
                commit("SET_TOKEN", response.data.token);
                commit("SET_EMAIL", response.data.email);
            } catch (err) {
                commit("SET_ERROR", "Email veya şifre hatalı!");
            } finally {
                commit("SET_LOADING", false);
            }
        },
        logout({ commit }) {
            commit("LOGOUT");
        },
    },
};
